import {Auth, API} from 'aws-amplify';
// import {Auth} from 'aws-amplify';
import {onAuthUIStateChange} from "@aws-amplify/ui-components";
import  { createWebHistory, createRouter }  from 'vue-router'

const routes = [
    {
        path: '/Track/:shipId/:shipZip?',
        name: 'Tracking',
        component: () => import('../components/TrackShipment.vue')
    },
    {
        path: '/PartnerShippingDashboard',
        name: 'PartnerShippingDashboard',
        component: () => import('../components/ShipmentDashboard/PartnerShippingDashboard/PartnerShippingDashboard.vue'),
        meta: { auth: true }
    },
    {
        path: '/QueuedActivitiesDashboard',
        name: 'QueuedActivitiesDashboard',
        component: () => import('../components/ShipmentDashboard/QueuedActivitiesDashboard/QueuedActivitiesDashboard.vue'),
        meta: { auth: true }
    },
    {
        path: '/ManifestDashboard',
        name: 'ManifestDashboard',
        component: () => import('../components/ShipmentDashboard/ManifestDashboard/ManifestDashboard.vue'),
        meta: { auth: true }
    },
    {
        path: '/CustomerManifestDashboard',
        name: 'CustomerManifestDashboard',
        component: () => import('../components/ShipmentDashboard/CustomerManifestDashboard/CustomerManifestDashboard.vue'),
        meta: { auth: true }
    },
    {
        path: '/RegisterCustomerPaymentForm',
        name: 'RegisterCustomerPaymentForm',
        component: () => import('../components/ShipmentDashboard/BillingDashboard/RegisterCustomerPaymentForm.vue'),
        meta: { auth: true }
    },
    {
        path: '/CreateAnnouncement',
        name: 'CreateAnnouncement',
        component: () => import('../components/ShipmentCenter/CreateAnnouncement.vue'),
        meta: { auth: true }
    },
    {
        path: '/Ship',
        name: 'Ship',
        component: () => import('../components/CreateShipment.vue'),
        meta: { auth: true }
    },
    {
        path: '/ShipmentCenter',
        name: 'ShipmentCenter',
        component: () => import('../components/ShipmentCenter/ShipmentCenter.vue'),
        meta: { auth: true }
    },
    {
        path: '/AdminBillingDashboard',
        name: 'AdminBillingDashboard',
        component: () => import('../components/ShipmentDashboard/BillingDashboard/AdminBillingDashboard.vue'),
        meta: { auth: true }
    },
    {
        path: '/CustomerBillingDashboard',
        name: 'CustomerBillingDashboard',
        component: () => import('../components/ShipmentDashboard/BillingDashboard/CustomerBillingDashboard.vue'),
        meta: { auth: true }
    },
    {
        path: '/CardManagement',
        name: 'CardManagement',
        component: () => import('../components/ShipmentDashboard/BillingDashboard/CloverCardManagement.vue'),
        meta: { auth: true }
    },
    {
        path: '/ShipmentDashboard',
        name: 'ShipmentDashboard',
        component: () => import('../components/ShipmentDashboard/ShipmentDashboard.vue'),
        meta: { auth: true }
    },
    {
        path: '/AdminShipmentDashboard',
        name: 'AdminShipmentDashboard',
        component: () => import('../components/ShipmentDashboard/AdminShipmentDashboard/AdminShipmentDashboard.vue'),
        meta: { auth: true }
    },
    {
        path: '/CustomerAdminShipmentDashboard',
        name: 'CustomerAdminShipmentDashboard',
        component: () => import('../components/ShipmentDashboard/CustomerAdminShipmentDashboard/CustomerAdminShipmentDashboard.vue'),
        meta: { auth: true }
    },
    {
        path: '/AdminUserManagementDashboard',
        name: 'AdminUserManagementDashboard',
        component: () => import('../components/ShipmentDashboard/AdminUserManagementDashboard/AdminUserManagementDashboard.vue'),
        meta: { auth: true }
    },
    {
        path: '/AnnouncementBoard',
        name: 'AnnouncementBoard',
        component: () => import('../components/ExtraPages/AnnouncementPage.vue'),
    },
    {
        path: '/PickupDashboard',
        name: 'PickupDashboard',
        component: () => import('../components/ShipmentDashboard/PickupDashboard/PickupDashboard.vue'),
        meta: { auth: true }
    },
    {
        path: '/SameDayDashboard',
        name: 'SameDayDashboard',
        component: () => import('../components/ShipmentDashboard/SameDayDashboard/SameDayDashboard.vue'),
        meta: { auth: true }
    },
    {
        path: '/IndependentContractor',
        name: 'IndependentContractor',
        component: () => import('../components/ExtraPages/ContractorPage.vue')
    },
    {
        path: '/TermsConditions',
        name: 'TermsConditions',
        component: () => import('../components/ExtraPages/TermsConditions.vue')
    },
    {
        path: '/AccountOnHold',
        name: 'AccountOnHold',
        component: () => import('../components/ExtraPages/AccountOnHold.vue'),
        meta: { auth: true }
    },
    {
        path: '/ShippingTC',
        name: 'ShippingTC',
        component: () => import('../components/ExtraPages/ShippingTC.vue')
    },
    {
        path: '/PrivacyPolicy',
        name: 'PrivacyPolicy',
        component: () => import('../components/ExtraPages/PrivacyPolicy.vue')
    },
    {
        path: '/CookiesPolicy',
        name: 'CookiesPolicy',
        component: () => import('../components/ExtraPages/CookiesPolicy.vue')
    },
    {
        path: '/CriticalMotionDates',
        name: 'CriticalMotionDates',
        component: () => import('../components/ExtraPages/CriticalMotionDates.vue')
    },
    {
        path: '/HolidaySchedule',
        name: 'HolidaySchedule',
        component: () => import('../components/ExtraPages/HolidaySchedule.vue')
    },
    {
        path: '/FuelSurcharge',
        name: 'FuelSurcharge',
        component: () => import('../components/ExtraPages/FuelSurcharge.vue')
    },
    {
        path: '/AdditionalCharges',
        name: 'AdditionalCharges',
        component: () => import('../components/ExtraPages/AdditionalCharges.vue')
    },
    {
        path: '/ContractorServices',
        name: 'ContractorServices',
        component: () => import('../components/ExtraPages/ContractorServices.vue')
    },
    {
        path: '/ZipShip',
        name: 'ZipShip',
        component: () => import('../components/ExtraPages/ZipShipContact.vue')
    },
    {
        path: '/AddressBook',
        name: 'AddressBook',
        component: () => import('../components/ShipmentCenter/AddressBook.vue')
    },
    {
        path: '/AddressBookDashboard',
        name: 'AddressBookDashboard',
        component: () => import('../components/ShipmentDashboard/AddressBook/AddressBookDashboard.vue'),
        meta: { auth: true }
    },
    {
        path: '/UserDashboard',
        name: 'UserDashboard',
        component: () => import('../components/ShipmentDashboard/UserDashboard/UserDashboard.vue'),
        meta: { auth: true }
    },
    {
        path: '/UserManagementDashboard',
        name: 'UserManagementDashboard',
        component: () => import('../components/ShipmentDashboard/UserManagementDashboard/UserManagementDashboard.vue'),
        meta: { auth: true }
    },
    {
        path: '/GeoCodeDashboard',
        name: 'GeoCodeDashboard',
        component: () => import('../components/ShipmentDashboard/GeoCodeDashboard/GeoCodeDashboard.vue'),
        meta: { auth: true }
    },
    {
        path: '/RouteDashboard',
        name: 'RouteDashboard',
        component: () => import('../components/ShipmentDashboard/RouteDashboard/RouteDashboard.vue'),
        meta: { auth: true }
    },
    {
        path: '/TripSheetDashboard',
        name: 'TripSheetDashboard',
        component: () => import('../components/ShipmentDashboard/TripSheetDashboard/TripSheetDashboard.vue'),
        meta: { auth: true }
    },
    {
        path: '/TripSheetErrorDashboard',
        name: 'TripSheetErrorDashboard',
        component: () => import('../components/ShipmentDashboard/TripSheetDashboard/TripSheetErrorDashboard.vue'),
        meta: { auth: true }
    },
    {
        path: '/ProductDashboard',
        name: 'ProductDashboard',
        component: () => import('../components/ShipmentDashboard/ProductDashboard/ProductDashboard.vue'),
        meta: { auth: true }
    },
    {
        path: '/AccountDashboard',
        name: 'AccountDashboard',
        component: () => import('../components/ShipmentDashboard/AccountDashboard/AccountDashboard.vue'),
        meta: { auth: true }
    },
    {
        path: '/UserAccountDashboard',
        name: 'UserAccountDashboard',
        component: () => import('../components/ShipmentDashboard/AccountDashboard/UserAccountDashboard.vue'),
        meta: { auth: true }
    },
    {
        path: '/CreateAccount',
        name: 'CreateAccount',
        component: () => import('../components/ShipmentDashboard/AccountDashboard/CreateAccount.vue')
    },
    {
        path: '/DropboxDashboard',
        name: 'DropboxDashboard',
        component: () => import('../components/ShipmentDashboard/DropboxDashboard/DropboxDashboard.vue'),
        meta: { auth: true }
    },
    {
        path: '/LocationDashboard',
        name: 'LocationDashboard',
        component: () => import('../components/ShipmentDashboard/LocationDashboard/LocationDashboard.vue'),
        meta: { auth: true }
    },
    {
        path: '/PlaceDashboard',
        name: 'PlaceDashboard',
        component: () => import('../components/ShipmentDashboard/PlaceDashboard/PlaceDashboard.vue'),
        meta: { auth: true }
    },
    {
        path: '/VehicleDashboard',
        name: 'VehicleDashboard',
        component: () => import('../components/ShipmentDashboard/VehicleDashboard/VehicleDashboard.vue'),
        meta: { auth: true }
    },
    {
        path: '/Login',
        name: 'Login',
        component: () => import('../components/ExtraPages/Login.vue')
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach(async (to, from, next) => {
    console.log("Route From: ", from)
    console.log("Route To: ", to)
    if (to.meta.auth) {
        if(to.path === '/AdminShipmentDashboard' || to.path === '/Ship' || to.path === '/ShipmentDashboard' || to.path === '/UserDashboard' || to.path === '/AddressBookDashboard' || to.path === '/CustomerAdminShipmentDashboard'){
            try {
                let cognitoUser = await Auth.currentAuthenticatedUser();
                console.log(cognitoUser)
                if (to.path === '/RegisterCustomerPaymentForm') {
                    next();
                    return; // Exit early
                }

                if (to.path === '/CardManagement') {
                    next();
                    return; // Exit early
                }

                onAuthUIStateChange(async (nextAuthState, authData) => {
                    console.log("NEXT AUTH STATE: ", nextAuthState)
                    console.log(authData)
                    if(nextAuthState === 'verifyContact'){
                        next({ path: '/Login' });
                        return;
                    }
                })

                const isBillable = await validateAccountUserBillable(cognitoUser.username);
                console.log("IS BILLABLE: ", isBillable)
                const userGroups = cognitoUser.signInUserSession.idToken.payload['cognito:groups'];

                console.log("USER GROUPS: ", userGroups)
                if(userGroups.includes('Admin') || userGroups.includes('InternalAdmin')){
                    next();
                    return;
                }

                if (isBillable.validCustomer) {
                    next();
                    return;
                } else {
                    if(isBillable.redirectTo === "CustomerBillingDashboard"){
                        if(userGroups.includes('BillingCustomer') || userGroups.includes('CustomerAdmin')){
                            next({ path: '/CustomerBillingDashboard', query: { msg: "billing_hold" } });
                            // alert("Access to the LRex platform requires that all invoices are paid. Thank you for your prompt attention to this matter.")
                            return;
                        }else{
                            next({ path: '/AccountOnHold' });
                            return;
                        }
                    }

                    if(isBillable.redirectTo === "StripePaymentSettings"){
                        if(userGroups.includes('BillingCustomer') || userGroups.includes('CustomerAdmin')){
                            await GetBillingPortalURL(isBillable.stripeID);
                        }else{
                            next({ path: '/AccountOnHold' });
                            return;
                        }
                    }
                }
            } catch (error) {
                console.error('Error during authentication or validation:', error);
                next({ path: '/Login' });
                return;
            }
        }else{
            try {
                let groupRouteAccess = {
                    Customer: ['/Ship', '/ShipmentDashboard', '/UserDashboard', '/AddressBookDashboard', '/CardManagement','/RegisterCustomerPaymentForm'],
                    Admin: ['/AdminShipmentDashboard', 
                            '/AccountDashboard', 
                            '/UserAccountDashboard', 
                            '/Ship', 
                            '/ShipmentDashboard', 
                            '/UserDashboard', 
                            '/AddressBookDashboard', 
                            '/AdminBillingDashboard',
                            '/CustomerBillingDashboard',
                            '/PickupDashboard',
                            '/SameDayDashboard',
                            '/LocationDashboard',
                            '/PlaceDashboard',
                            '/DropboxDashboard',
                            '/RouteDashboard',
                            '/ManifestDashboard',
                            '/ProductDashboard',
                            '/PartnerShippingDashboard',
                            '/AdminUserManagementDashboard',
                            '/QueuedActivitiesDashboard', 
                            '/CardManagement',
                            '/RegisterCustomerPaymentForm',
                            '/CreateAnnouncement',
                            '/CustomerAdminShipmentDashboard',
                            '/UserManagementDashboard',
                            '/TripSheetDashboard',
                            '/TripSheetErrorDashboard'
                        ],
                    InternalAdmin: [
                            '/AdminShipmentDashboard', 
                            '/AccountDashboard', 
                            '/Ship', 
                            '/ShipmentDashboard', 
                            '/UserDashboard', 
                            '/AddressBookDashboard', 
                            '/AdminBillingDashboard',
                            '/CustomerBillingDashboard',
                            '/PickupDashboard',
                            '/SameDayDashboard',
                            '/LocationDashboard',
                            '/PlaceDashboard',
                            '/DropboxDashboard',
                            '/RouteDashboard',
                            '/ManifestDashboard',
                            '/ProductDashboard',
                            '/PartnerShippingDashboard',
                            '/AdminUserManagementDashboard',
                            '/QueuedActivitiesDashboard', 
                            '/CardManagement',
                            '/RegisterCustomerPaymentForm',
                            '/CreateAnnouncement',
                            '/CustomerAdminShipmentDashboard',
                            '/UserManagementDashboard',
                            '/TripSheetDashboard',
                            '/TripSheetErrorDashboard',
                            '/UserAccountDashboard'
                        ],
                    CustomerAdmin: ['/CustomerAdminShipmentDashboard', '/UserAccountDashboard', '/Ship', '/ShipmentDashboard', '/UserDashboard', '/UserManagementDashboard', '/AddressBookDashboard', '/CardManagement', '/RegisterCustomerPaymentForm', '/CustomerBillingDashboard'],
                    BillingCustomer : ['/CustomerBillingDashboard', '/UserAccountDashboard'],
                    CustomerManifest: ['/CustomerManifestDashboard']
                };

                let cognitoUser = await Auth.currentAuthenticatedUser();

                const userGroups = cognitoUser.signInUserSession.idToken.payload['cognito:groups'];

                if (userGroups && userGroups.length) {
                    // Check if any of the user's groups allow access to the route
                    const hasAccess = userGroups.some(group => {
                        const allowedRoutes = groupRouteAccess[group];
                        return allowedRoutes && allowedRoutes.includes(to.path);
                    });

                    if (hasAccess) {
                        next();
                        return;
                    } else {
                        alert('Access denied.');
                    }
                } else {
                    alert('Access denied. No groups assigned.');
                }

                onAuthUIStateChange(async (nextAuthState, authData) => {
                    console.log(authData)
                    if(nextAuthState === 'verifyContact'){
                        next({ path: '/Login' });
                        return;
                    }
                })

                next();
            } catch (error) {
                console.error('Error during authentication or validation:', error);
                next({ path: '/Login' });
                return;
            }
        }
    } else {
        console.log('No authentication required. Proceeding...');
        next();
        return;
    }
});

// router.beforeResolve((to, from, next)=>{
//     if(to.meta.auth){
//         Auth.currentAuthenticatedUser().then(()=>{
//             //Should be redirected
//             next()
//         }).catch(()=>{
//             //The user is not authenticated
//             next({
//                 path: '/Login'
//               });
//         });
//     }else{
//         next();
//     }
    
// });

async function GetBillingPortalURL(StripeCustomerID){

    try{
        let sessionURL = await API.graphql({
        query:  `mutation GetStripeCustomerPortal($input: getStripeCustomerPortalInput!) {
          getStripeCustomerPortal(input: $input) {
            sessionURL
          }
        }`,
        variables:{ input:{ customerID: StripeCustomerID, returnURL: window.location.href } },
        authMode: "AMAZON_COGNITO_USER_POOLS",
        })
        console.log(sessionURL)
        if(sessionURL.data?.getStripeCustomerPortal?.sessionURL){
            window.location.href = sessionURL.data.getStripeCustomerPortal.sessionURL;
            alert("You must add a payment method to access the LREX platform.")
        }else{
            alert("Error opening billing portal. Contact support to fix LREX billing account.")
            Auth.signOut({global: false})
            router.push('/Login');
        }
    }catch(e){
        console.log(e)
        if(e){
            alert("Error opening billing portal.")
        }
    }
}

async function validateAccountUserBillable(username){
    try {
        let userReturnData = await API.graphql({
            query: `query GetUser($userName: String!){
                getUser(userName: $userName){
                    accountNo
                }
            }`,
            variables: {
                    userName: username
            },
            authMode: "AMAZON_COGNITO_USER_POOLS",
        })
        let userData = userReturnData.data.getUser;
        console.log("USER DATA: ", userData)
        // let accountData = await GetAccountGraphQL(userData.accountNo)
        // let openInvoicesLength = await openInvoicesByAccountNo(userData.accountNo);
        // console.log(openInvoicesLength)
        // const hasPaymentMethod = Array.isArray(accountData.paymentMethods) && accountData.paymentMethods.length > 0;

        // const hasOpenInvoice = openInvoicesLength > 0;

        // // 1) Billable -> no further check required
        // if (accountData.billable === true) {
        //     console.log("ACCOUNT IS BILLABLE = TRUE");
        //     return { validCustomer: true };
        // }

        // // 2) Not billable -> needs payment method + no open invoices
        // if (!hasPaymentMethod) {
        //     console.log("NOT BILLABLE + NO PAYMENT METHOD -> STRIPE SETTINGS");
        //     return {
        //         validCustomer: false,
        //         stripeID: accountData.stripeID,
        //         redirectTo: "StripePaymentSettings",
        //     };
        // }

        // if (hasOpenInvoice) {
        //     console.log("NOT BILLABLE + HAS PAYMENT METHOD + OPEN INVOICE -> BILLING DASHBOARD");
        //     return {
        //         validCustomer: false,
        //         stripeID: accountData.stripeID,
        //         redirectTo: "CustomerBillingDashboard",
        //     };
        // }

        // // Has payment method AND no open invoice -> continue
        // console.log("NOT BILLABLE + HAS PAYMENT METHOD + NO OPEN INVOICE");
        // return { validCustomer: true };

        let accountData = await GetAccountGraphQL(userData.accountNo);
        let openInvoicesLength = await openInvoicesByAccountNo(userData.accountNo, accountData.paymentDays ?? 31);
        console.log(openInvoicesLength);

        const hasPaymentMethod =
        Array.isArray(accountData.paymentMethods) &&
        accountData.paymentMethods.length > 0;

        const hasOldOpenInvoice = openInvoicesLength > 0;
        //paymentDays is the number of days we are giving the account to pay an invoice before restricting access
        // 1) Billable -> no further check required
        if (accountData.billable === true) {
            console.log("ACCOUNT IS BILLABLE = TRUE");
            return { validCustomer: true };
        }

        // 2) Not billable + NO open invoice older than paymentDays days -> no further check
        if (!hasOldOpenInvoice) {
            console.log("NOT BILLABLE + NO OLD OPEN INVOICE (<= paymentDays DAYS)");
            return { validCustomer: true };
        }

        // 3) Not billable + HAS open invoice older than paymentDays days -> must resolve billing
        if (!hasPaymentMethod) {
            console.log("NOT BILLABLE + OLD OPEN INVOICE + NO PAYMENT METHOD -> STRIPE SETTINGS");
            return {
                validCustomer: false,
                stripeID: accountData.stripeID,
                redirectTo: "StripePaymentSettings",
            };
        }

        // 4) Not billable + OLD open invoice + HAS payment method
        console.log("NOT BILLABLE + OLD OPEN INVOICE + HAS PAYMENT METHOD -> BILLING DASHBOARD");
        return {
            validCustomer: false,
            stripeID: accountData.stripeID,
            redirectTo: "CustomerBillingDashboard",
        };
    } catch (error) {
        console.log(error)
    }
}

async function openInvoicesByAccountNo(accountNo, paymentDays) {
    let nextToken = null;
    let invoiceTableData = [];
    let invoiceByAccountNo;
    
    const now = new Date();
    const cutoffDate = new Date();
    cutoffDate.setDate(now.getDate() - paymentDays);

    // Any invoice with postDate < cutoff is "older than paymentDays days"
    const filterDateRange = `,filter: {
        invoicePostDate: {
            lt: "${cutoffDate.toISOString()}"
        }
    }`;

    const dateFilter = filterDateRange;

    invoiceByAccountNo = `query invoiceByAccountNo {
        invoiceByAccountNo(
            accountNo: "${accountNo}",
            status: { eq: "O" }${dateFilter},
            nextToken: ${nextToken ? `"${nextToken}"` : null}
        ) {
            items {
            invoiceID
            status
            invoicePostDate
            }
            nextToken
        }
    }`;

    do {
        try {
            let getInvoices = await API.graphql({
                query: invoiceByAccountNo,
                variables: {
                    accountNo: accountNo,
                    nextToken
                },
                authMode: "AMAZON_COGNITO_USER_POOLS",
            });

            const { items, nextToken: newNextToken } = getInvoices.data.invoiceByAccountNo;
            invoiceTableData = invoiceTableData.concat(items);
            nextToken = newNextToken;
        } catch (e) {
            break; // Exit the loop if there's an error
        }
    } while (nextToken);

    return invoiceTableData.length;
}

async function GetAccountGraphQL(accountNo){
    try {
        let accountReturnData = await API.graphql({
            query: `query getAccount($accountNo: String!){
                getAccount(accountNo: $accountNo){
                    billable
                    cardOnFileCount
                    paymentMethods
                    stripeID
                    paymentDays
                }
            }`,
            variables: {
                    accountNo: accountNo
            },
            authMode: "AMAZON_COGNITO_USER_POOLS",
        })
        let accountData = accountReturnData.data.getAccount;
        console.log("ACCOUNT DATA: ", accountData)
        return accountData;
    } catch (error) {
        console.log(error)
    }
}

export default router